import React from "react";

export const getPostsFromQuery = (data) => {
  const posts = data.allMdx.edges.map((edge) => {
    const post = {
      key: edge.node.fields.slug,
      excerpt: edge.node.excerpt,
      fileName: edge.node.parent?.name,
      ...edge.node.fields,
      ...edge.node.frontmatter,
    };

    if (post.url) {
      post.category = "news";
    }

    return post;
  });

  return process.env.NODE_ENV === "production"
    ? posts.filter((post) => !post.fileName?.startsWith("_"))
    : posts;
};

export const renderTitleWithEmphasis = (title, emphasis) => {
  return title
    .split(/\b/)
    .map((text, index) =>
      text === emphasis ? <em key={index}>{text}</em> : text
    );
};
